import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  ${(props) => props.scale && css`
    transform: scale(${props.scale});
  `}
`;

export const Embed = styled.div`
  position: relative;
  z-index: 0;
`;

export const Mask = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/components/InstagramEmbed/style.js